<section class="content">
  <div class="card" style="padding: 24px;">

    <div class="container">
      <div class="row">
        <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
          {{title}}
        </div>
      </div>
      <div class="row">
        <!-- From Period -->
        <div class="col-3">
          <label>From Period <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
          <mat-select class="main-border-class" [(ngModel)]="from_period" (selectionChange)="updateToPeriodOptions()">
            <mat-option *ngFor="let period of from_period_list" [value]="period">
              {{period.month_in_string}} - {{period.year}}
            </mat-option>
          </mat-select>
        </div>

        <!-- To Period -->
        <div class="col-3">
          <label>To Period <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
          <mat-select class="main-border-class" [(ngModel)]="to_period">
            <mat-option *ngFor="let period of to_period_list" [value]="period">
              {{period.month_in_string}} - {{period.year}}
            </mat-option>
          </mat-select>
        </div>

        <!-- Get Button -->
        <div class="col-3">
          <button (click)="getClicked()"
            style="font-size: 27px;margin-top: 10%;border-radius: 5px;background: blanchedalmond;"
            [disabled]="from_period == null || to_period == null">Get</button>
        </div>
        <div *ngIf="!is_document_available" style='padding-top: 25px;' class="col-2">
          <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
          </mat-progress-spinner>
        </div>
        <div class="col-2" *ngIf="document_file!== null" style='padding-top: 25px;'>
          <button mat-button class="button-class" (click)="downloadClicked()" style="margin-top: 7px;"><i
              class="material-icons">
              picture_as_pdf
            </i> Download report</button>
        </div>

      </div>
      <br>
    </div>
  </div>
</section>